// extracted by mini-css-extract-plugin
module.exports = {"signInForm":"SignIn_signInForm__1MTfb","forgotPassword":"SignIn_forgotPassword__3CQsV"};